var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (Object, capitalizeFirstLetter, changelog, renderMarkDown) {pug_mixins["changelog-item"] = pug_interp = function(release){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate Object.keys(release.changelog)
;(function(){
  var $$obj = Object.keys(release.changelog);
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var key = $$obj[pug_index0];
pug_html = pug_html + "\u003Ch3\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(key.replace(/"/g, ''))) ? "" : pug_interp)) + "\u003C\u002Fh3\u003E\u003Cul class=\"changelog\"\u003E";
// iterate release.changelog[key]
;(function(){
  var $$obj = release.changelog[key];
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var log = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli\u003E\u003Cspan class=\"label label-default\"\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(log.module)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"log-description\"\u003E " + (null == (pug_interp = renderMarkDown(log.description)) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var log = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli\u003E\u003Cspan class=\"label label-default\"\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(log.module)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"log-description\"\u003E " + (null == (pug_interp = renderMarkDown(log.description)) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var key = $$obj[pug_index0];
pug_html = pug_html + "\u003Ch3\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(key.replace(/"/g, ''))) ? "" : pug_interp)) + "\u003C\u002Fh3\u003E\u003Cul class=\"changelog\"\u003E";
// iterate release.changelog[key]
;(function(){
  var $$obj = release.changelog[key];
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var log = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli\u003E\u003Cspan class=\"label label-default\"\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(log.module)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"log-description\"\u003E " + (null == (pug_interp = renderMarkDown(log.description)) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var log = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli\u003E\u003Cspan class=\"label label-default\"\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(log.module)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"log-description\"\u003E " + (null == (pug_interp = renderMarkDown(log.description)) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
    }
  }
}).call(this);

};
pug_html = pug_html + "\u003Cdiv class=\"changelog-page\"\u003E\u003Csection class=\"jumbotron has-header\"\u003E\u003Ch2\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fchangelog\u002Fimg\u002Fchangelog-c894862bd1.svg\"\u003E\u003C\u002Fh2\u003E\u003Ch1\u003EAuth0 Appliance Release Notes\u003C\u002Fh1\u003E\u003Cp\u003EGet the latest updates in Auth0\u003C\u002Fp\u003E\u003C\u002Fsection\u003E\u003Csection class=\"categories\"\u003E\u003Cdiv class=\"container\" id=\"changelog\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-12 center left-side\"\u003E\u003Cdiv class=\"category\" id=\"appliance\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-3\"\u003E\u003Cdiv class=\"sidebar-box\"\u003E\u003Cstrong\u003EReleases\u003C\u002Fstrong\u003E\u003Cul\u003E";
// iterate changelog
;(function(){
  var $$obj = changelog;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var release = $$obj[pug_index3];
pug_html = pug_html + "\u003Cli\u003E\u003Ca" + (pug.attr("href", '#' + release.id, true, true)+" data-control=\"release\"") + "\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = release.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var release = $$obj[pug_index3];
pug_html = pug_html + "\u003Cli\u003E\u003Ca" + (pug.attr("href", '#' + release.id, true, true)+" data-control=\"release\"") + "\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = release.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-9 text-content\"\u003E\u003Ca href=\"\u002Fchangelog\u002Fappliance\u002Fold\"\u003ESee old releases\u003C\u002Fa\u003E";
// iterate changelog
;(function(){
  var $$obj = changelog;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var release = $$obj[pug_index4];
pug_html = pug_html + "\u003Ca" + (pug.attr("name", release.id, true, true)) + "\u003E\u003C\u002Fa\u003E\u003Ch2\u003E" + (pug.escape(null == (pug_interp = release.title) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E";
pug_mixins["changelog-item"](release);
pug_html = pug_html + "\u003Chr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var release = $$obj[pug_index4];
pug_html = pug_html + "\u003Ca" + (pug.attr("name", release.id, true, true)) + "\u003E\u003C\u002Fa\u003E\u003Ch2\u003E" + (pug.escape(null == (pug_interp = release.title) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E";
pug_mixins["changelog-item"](release);
pug_html = pug_html + "\u003Chr\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";}.call(this,"Object" in locals_for_with?locals_for_with.Object:typeof Object!=="undefined"?Object:undefined,"capitalizeFirstLetter" in locals_for_with?locals_for_with.capitalizeFirstLetter:typeof capitalizeFirstLetter!=="undefined"?capitalizeFirstLetter:undefined,"changelog" in locals_for_with?locals_for_with.changelog:typeof changelog!=="undefined"?changelog:undefined,"renderMarkDown" in locals_for_with?locals_for_with.renderMarkDown:typeof renderMarkDown!=="undefined"?renderMarkDown:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/changelog/appliance-page.pug
// module id = 1064
// module chunks = 0